<template>
  <v-layout row class="ma-2">
    <v-flex md8>
      <v-card tile :loading="loading_data">
        <slot />
        <v-card-actions v-if="$slots.actions">
          <v-spacer />
          <slot name="actions" />
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: 'v-settings',
  props: {
    loading_data: Boolean
  }
}
</script>